/* DevīCo experience polish v25.2.0 */
(() => {
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.toggle('devico-reduced-motion', Boolean(reduceMotion));

  // Focus the first error or success message after a Shopify form submission rerender.
  const focusMessage = document.querySelector('.contact-form__errors, .contact-form .form-message, .devico-auth__error');
  if (focusMessage && focusMessage.matches('[tabindex="-1"]')) {
    requestAnimationFrame(() => focusMessage.focus({ preventScroll: false }));
  }

  // Ensure in-page article links do not land underneath the sticky site header.
  document.querySelectorAll('.devico-article__body a[href^="#"]').forEach(link => {
    link.addEventListener('click', event => {
      const id = decodeURIComponent(link.getAttribute('href').slice(1));
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      history.replaceState(null, '', `#${encodeURIComponent(id)}`);
    });
  });
})();
